export enum EnumTipoResidencia {
  Residente = 1,
  ResidenteUE,
  Extranjero
}
